<template>
  <el-select
    :value="intercomId"
    filterable
    clearable
    remote
    :size="size"
    placeholder="Домофоны"
    style="width: 100%"
    :loading="loading && !intercoms.length"
    :remote-method="remoteMethod"
    @change="change"
    @clear="clear"
  >
    <el-option
      v-for="intercom in intercoms"
      :key="intercom.id_intercom"
      :value="intercom.id_intercom"
      :label="intercom.short_name"
    >
      <span style="float: left">{{ intercom.short_name }}</span>
      <span style="float: right; margin-left: 20px; color: #8492a6; font-weight: normal">{{ intercom.uuid }}</span>
    </el-option>
    <el-option
      v-if="total && total - intercoms.length"
      :value="0"
      disabled
      style="align-items: center; text-align: center"
    >
      <el-button :loading="loading && !queryLoading" type="text" style="width: 100%" size="mini" @click="nextPage">
        {{ loading && !queryLoading ? "Загрузка" : "Показать ещe" }}
      </el-button>
    </el-option>
  </el-select>
</template>

<script>
import { ApiService } from "@/api";

export default {
  name: "SelectIntercom",
  model: {
    prop: "intercom-id",
    event: "change",
  },
  props: {
    cameraId: {
      type: Number,
      default: null,
    },
    intercomId: {
      type: Number,
      default: null,
    },
    size: {
      type: String,
      default: "small",
    },
  },
  data() {
    return {
      page: 1,
      query: "",
      total: 0,
      queryLoading: false,
      loading: false,
      intercoms: [],
    };
  },
  mounted() {
    if (this.intercomId) {
      this.loading = true;
      ApiService.intercoms.get(this.intercomId).then((intercom) => {
        this.intercoms = [intercom];
      });
    }
    this.pullIntercoms(true);
  },
  watch: {
    cameraId(){
      this.pullIntercoms(true);
    }
  },
  methods: {
    clearData() {
      this.page = 1;
      this.total = 0;
      this.intercoms = [];
    },
    remoteMethod(query) {
      this.queryLoading = true;
      this.query = encodeURI(query);
      this.clearData();
      this.pullIntercoms().finally(() => {
        this.queryLoading = false;
      });
    },
    nextPage() {
      this.page = this.page + 1;
      this.pullIntercoms(true);
    },
    pullIntercoms(update = false) {
      const { page, query: search } = this;

      this.loading = true;

      var idCamera = "";
      if (this.cameraId !== null) {
        idCamera = this.cameraId
      }
      return ApiService.intercoms
        .getList({ search, page, count: 10, id_camera: idCamera })
        .then(({ data: intercoms, total }) => {
          this.total = total;
          this.intercoms = (update ? [...this.intercoms, ...intercoms] : intercoms).filter((intercom, index, array) => {
            return !array.slice(index + 1).find((c) => c.id_intercom === intercom.id_intercom);
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    change(id) {
      const selectedIntercom = this.intercoms.find((m) => m.id_intercom === id);
      if (selectedIntercom !== undefined) {
        this.$emit("change", selectedIntercom);
      }
    },
    clear() {
      this.$emit("clear");
    }
  },
};
</script>
